import { getIDB, setIDB } from '@/utils/indexedDb';

class ABTestAssignerFactory {
  static createAssigner(type: 'random' | 'onlyA' | 'onlyB'): ABTestAssigner {
    switch (type) {
      case 'random':
        return new RandomABTestAssigner();
      case 'onlyA':
        return new OnlyAABTestAssigner();
      case 'onlyB':
        return new OnlyBABTestAssigner();
      default:
        return new RandomABTestAssigner();
    }
  }
}

/***
 * AB 테스트 할당합니다.
 *
 * 1. indexedDB 에 저장된 AB 테스트 데이터를 가져옵니다
 * 2. 가져온 데이터가 없으면 새로 할당과 함께 저장합니다.
 */
export const getAbType = async (): Promise<'A' | 'B'> => {
  const abTest = await getIDB('abTest');
  if (abTest === 'A' || abTest === 'B') {
    return abTest;
  }

  // 필요시 변경
  const assigner = ABTestAssignerFactory.createAssigner('random');
  const abType = assigner.assign();
  setIDB('abTest', abType);
  return abType;
};

interface ABTestAssigner {
  assign(): 'A' | 'B';
}

class RandomABTestAssigner implements ABTestAssigner {
  assign(): 'A' | 'B' {
    const ab = Math.random() < 0.5 ? 'A' : 'B';
    return ab;
  }
}

class OnlyAABTestAssigner implements ABTestAssigner {
  assign(): 'A' | 'B' {
    return 'A';
  }
}

class OnlyBABTestAssigner implements ABTestAssigner {
  assign(): 'A' | 'B' {
    return 'B';
  }
}
